import React, { useEffect, useState } from "react";
import Menu from "./Menu";
import SidebarData from "./Sidebar.data";
import "./sidebar.css";
import { NumberFormat as numberUtils } from "../../utilities/NumberFormat";
import AuthService from "../../services/Auth.service";
import { useHistory } from "react-router-dom";
import { checkPermission } from "../../utilities/hasPermission";

function Sidebar({ setOpen, sidebarToggle, toggle }) {
  const [user, setUser] = useState(null);
  const [authed, setAuthed] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setAuthed(AuthService.isAuthenticated());
    setUser(AuthService.getCurrentUser());
  }, []);

  const logout = () => {
    AuthService.logout();
    history.push("/");
    numberUtils.tabTitle("Login");
  };

  const username = user?.name || "Guest";
  const accessRole = (user?.access || "").toLowerCase();

  if (!authed) return null;

  return (
    <aside
      className={`main-sidebar sidebar-dark-primary ${sidebarToggle ? "closeSidebar" : "opensidebar"}`}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "250px",
        height: "100vh", // full height
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxShadow: "0px 10px 11px 0px #00000040",
      }}
    >
      {/* Logo fixed at top */}
      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <a href="#">
          <img src="/assets/images/logo-home.png" height={65} alt="Logo" />
        </a>
      </div>

      {/* Scrollable menu */}
      {/* Scrollable menu with thin scrollbar */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingTop: "10px",
          WebkitOverflowScrolling: "touch",
        }}
        className="main-sidebar-new"
      >
        <style>
        </style>

        <nav className="navbox">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
            style={{ padding: 0, margin: 0, listStyle: "none" }}
          >
            {SidebarData &&
              SidebarData.map((val, key) => {
                const hasPermission = val.permission ? checkPermission.hasPermission(val.permission) : true;
                if (hasPermission) {
                  return <Menu key={key} data={val} toggle={toggle} setOpen={setOpen} />;
                }
                return null;
              })}
          </ul>
        </nav>
      </div>

    </aside>


  );
}

export default Sidebar;
